// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mpfEntity from './entities/mpf.json';
import mpfMenu from '../pages/mpf/menu.json';
import mpfFullForm from '../pages/mpf/forms/full.json';
import mpfContextForm from '../pages/mpf/forms/context.json';
import mpfMiniForm from '../pages/mpf/forms/mini.json';
import mpfLookupForm from '../pages/mpf/forms/lookup.json';
import mpfTableView from '../pages/mpf/views/table.json';
import mpfStagesView from '../pages/mpf/views/stages.json';
import mpfCardsView from '../pages/mpf/views/cards.json';
import mpfInlineView from '../pages/mpf/views/inline.json';
import mpfBacklogView from '../pages/mpf/views/backlog.json';
import mpfSplitView from '../pages/mpf/views/split.json';
import mpfCalendarView from '../pages/mpf/views/calendar.json';
import mpfDashboardView from '../pages/mpf/views/dashboard.json';

/** Тип запису «Бюджетна стаття» зі сторінками пакета: меню, форми та подання з pages/mpf/. */
export const mpfDefinition: IRecordTypeDefinition = {
  ...mpfEntity,
  views: assembleViewSet({
      table: mpfTableView,
      stages: mpfStagesView,
      cards: mpfCardsView,
      inline: mpfInlineView,
      backlog: mpfBacklogView,
      split: mpfSplitView,
      calendar: mpfCalendarView,
      dashboard: mpfDashboardView,
  }),
  form: mpfFullForm,
  forms: { full: mpfFullForm, context: mpfContextForm, mini: mpfMiniForm, lookup: mpfLookupForm },
  menu: mpfMenu,
} as IRecordTypeDefinition;
